import React, { PropsWithChildren } from 'react';

import useStyles from './styles';

import Title from '../Title';

interface Props {
    title?: React.ReactNode;
    className?: string;
}

const Advantages: React.FC<PropsWithChildren<Props>> = ({ title, children, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            <Title variant="h2">{title}</Title>
            <div className={classes.items}>{children}</div>
        </div>
    );
};

export default Advantages;
